import { FC } from "react";
import { IFlowyProject } from "flowy-3-core";
import FlowyFoundation from "../FlowyFoundation/FlowyFoundation";
import {
  quintanaRooHeader,
  quintanaRooSeparator,
} from "../../../../assets/images";
import * as S from "./FlowyProject.styles";
import usePlatformCB from "../../../../client/usePlatformCB";

type NavbarProps = {
  config: IFlowyProject;
};

const Navbar: FC<NavbarProps> = ({ config }) => {
  const { platformOperationCB } = usePlatformCB();
  return (
    <S.Navbar>
      <img
        src={quintanaRooHeader}
        alt="Encabezado Quintana Roo"
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      ></img>
      <img
        src={quintanaRooSeparator}
        alt="Navbar Separator"
        style={{
          maxWidth: "100%",
        }}
      ></img>
      {config.navbar?.gizmos &&
        Array.isArray(config.navbar.gizmos) &&
        config.navbar.gizmos.length === 1 && (
          <FlowyFoundation
            config={config.navbar.gizmos[0]}
            platformCallbacks={{
              platformOperationCB,
            }}
          />
          // <div>Gizmos {config.navbar.gizmos[0].fid}</div>
        )}
    </S.Navbar>
  );
};

export default Navbar;
